import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardNameMatcherComponent } from './card-name-matcher.component';

@NgModule({
  declarations: [CardNameMatcherComponent],
  exports: [CardNameMatcherComponent],
  imports: [CommonModule],
})
export class CardNameMatcherModule {}
